import SearchIcon from '@flipster/react/icon/generated/SearchIcon';
import XCircleIcon from '@flipster/react/icon/generated/XCircleIcon';
import { useControllableState } from '@flipster/react/misc/state/use-controllable-state';
import { Styles, css, cx } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { map } from '@flipster/utils/map';

interface Props {
  value?: string;
  defaultValue?: string;
  placeholder: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  css?: Styles;
}

// Copy from `apps/web/app/[locale]/(web)/support/affiliate/SearchInput.tsx
const ClearableSearchInput = ({ value, defaultValue = '', placeholder, onChange, onClear, css: cssProp }: Props) => {
  const [innerValue, setInnerValue] = useControllableState<string>({
    value,
    defaultValue,
    onChange,
  });

  return (
    <div
      className={cx(
        flex({
          align: 'center',
          gap: 12,
          minH: 40,
          px: 16,
          bg: 'background.default.level-1',
          rounded: 8,
        }),
        map(cssProp, css),
      )}
    >
      <SearchIcon size={20} />
      <input
        type='text'
        value={innerValue}
        onChange={(e) => {
          setInnerValue(e.currentTarget.value);
        }}
        size={10}
        placeholder={placeholder}
        className={css({
          flex: 1,
          color: 'inverse.white',
          _placeholder: {
            color: 'content.interaction.disabled',
          },
        })}
      />
      {innerValue && (
        <button
          type='button'
          className={css({ w: 20, h: 20, color: 'content.default.level-1' })}
          onClick={() => {
            setInnerValue('');
            onClear?.();
          }}
        >
          <XCircleIcon size={20} />
        </button>
      )}
    </div>
  );
};

export default ClearableSearchInput;
